import { AnchorHTMLAttributes } from 'react';

import { env } from 'config/env';
import { useLang } from 'locale';
import { joinUrl } from 'utils/url';

type LinkProps = AnchorHTMLAttributes<HTMLAnchorElement>;

export function PrivacyPolicyLink(props: LinkProps) {
  const { t } = useLang();

  return (
    <a href={joinUrl(env.mailUrl, '/policies/privacy')} target="privacy-policy" {...props}>
      {t('privacy-policy')}
    </a>
  );
}

export function UseTermsLink(props: LinkProps) {
  const { t } = useLang();

  return (
    <a href={joinUrl(env.mailUrl, '/policies/terms')} target="terms" {...props}>
      {t('terms-of-use')}
    </a>
  );
}
